import { render, staticRenderFns } from "./ShiftDetail.vue?vue&type=template&id=6bb73574"
import script from "./ShiftDetail.vue?vue&type=script&lang=ts"
export * from "./ShiftDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports